module.exports = __webpack_public_path__ + "img/pro_edition.dd3f156e.png";